import UserLocationPopup from './user-location-popup'
//import ProductGarnish from "./product-garnish"
import Garnish from './garnish'
import Cookies from 'js-cookie'

(function ($) {
  'use strict'
  window.$ = window.jQuery = $
  $(function () {

    window.Garnish = Garnish

    window.quantityChangingOperations = {};
    window.quantityChangingOperations.products = {}
    window.quantityChangingOperations.productsTasks = {}

    var current_date = $(document).find('.js-catalog-menu-day').data('date');
    var select_date = $(document).find('.js-catalog-menu-day.day_active').data('date');

    var stoplistProducts = [];
    var stoplistOffers = [];

    window.getFormattedPriceAsText = function(price) {
        if ( typeof price !== 'number' ) {
            price = parseFloat(price);

            if ( isNaN(price) ) {
                throw new Error('Price must to be the number')
            }
        }

        return price.toLocaleString().replace(',', ' ').replace('.', ',') + ' ₽';
    }

// Изменяет доступность торгового предложения
    window.revealHolidayMenu = function ($box = false) {
      if ($box !== false) {
        let $happyNY = $box.find('#new-year-menu')
        if ($happyNY.length) {
          console.log($happyNY)
          $happyNY.foundation()
          $happyNY.foundation('open')
        }
      } else {
        let $happyNY = $(document).find('#new-year-menu')
        if ($happyNY.length) {
          console.log($happyNY)
          $happyNY.foundation('open')
        }
      }
    }

// Изменяет доступность торгового предложения
    window.stopListOfferGarnishAvailability = function ($option, id, availability = true) {
      var $boxGarnish = $option.parents('.x-garnish-box')
      if (availability) {
        if ($option.hasClass('hide')) {
          $option.attr('disabled', false).removeAttr('hidden').removeClass('hide')
          $boxGarnish.find('.product__garnish-option[data-value="' + id + '"]').removeClass('hide')
          $boxGarnish.find('.garnish__option[data-value="' + id + '"]').removeClass('hide')
        }
      } else {
        if (!$option.hasClass('hide')) {
          $option.attr('disabled', true).attr('hidden', true).addClass('hide')
          $boxGarnish.find('.product__garnish-option[data-value="' + id + '"]').addClass('hide')
          $boxGarnish.find('.garnish__option[data-value="' + id + '"]').addClass('hide')
        }
      }
    };

// Делаем торговые предложения доступными
    window.stopListOffersClear = function ($box) {
      if ($box.find('.x-product-portion-box').length) {
        console.log('stopListOffersClear - portion')
        var $boxPortion = $box.find('.x-product-portion-box')
        $boxPortion.each(function () {
          var $portionBox = $(this)
          $portionBox.find('.x-product-portion').each(function () {
            var $input = $(this),
              idOffer = $input.attr('data-offer'),
              $label = $portionBox.find('[for="input-garnish-' + idOffer + '"]')
            $input.removeClass('hide')
            $label.removeClass('hide')
          })
          $portionBox.removeClass('hide')
        })
      } else if ($box.find('.x-garnish-select').length) {
        var $selectGarnish = $box.find('.x-garnish-select')
        $selectGarnish.find('option').each(function () {
          window.stopListOfferGarnishAvailability($(this), $(this).attr('data-offer'), false)
        })
      }
    }


// Доступность комбо для выбранного дня в календаре
    window.comboAvailableForDaySection = function () {
      let $xSectionCombo = $(document).find('.x-combo-section')
      if ($xSectionCombo.length) {
        $.ajax({
          type: 'POST',
          url: '',
          dataType: 'html',
          processData: false,
          contentType: false,
          success: function (result) {
            $xSectionCombo.html($('<div />').html(result).find('.x-combo-section').html())
            window.listBasketItemsDay()
            setTimeout(function() {
              var height = $('.x-dinner-box').height();
              $('.x-combo-detail-scrollfix').height(height);
              setTimeout(function() {
                height = $('.x-dinner-box').height();
                $('.x-combo-detail-scrollfix').height(height);
              }, 500);
            }, 500);
          }
        })
      }
    }



    window.revealHolidayMenu()

    /** @todo REMOVE this */
    let happyNewYearNotWorking = $('#happyNewYearNotWorking')
    if (happyNewYearNotWorking.length) {
      happyNewYearNotWorking.foundation()
      happyNewYearNotWorking.foundation('open')
    }

    window.scrollDetailCombo = function () {
      if ($(document).find('.x-combo-detail-dinner.dinner_active').length) {
        var offsetTop = $(document).find('.x-combo-detail-dinner.dinner_active').offset().top,
          $scrollTopBox = $(document).find('.x-combo-detail-scrollfix'),
          scrollTop = offsetTop - $scrollTopBox.innerHeight()
        if (scrollTop > 0) {
          $scrollTopBox.scrollTop(scrollTop)
        }
      }
    }
    window.scrollDetailCombo()

    window.happyNewYearNotWorking = function (ajaxRes) {
      try {
        if (!ajaxRes.success && ajaxRes.newYear) {
          let happyNewYearNotWorking = $('#happyNewYearNotWorking')
          happyNewYearNotWorking.foundation()
          happyNewYearNotWorking.foundation('open')
        }
      } catch (e) {
        console.log(e)
      }
    }

    // Изменение количества товаров
    window.changeQuantityProduct = function ($addButtonBox, action = 'add') {

      var data = new FormData(),
        $addQuantityBox = $addButtonBox.find('.x-add-quantity'),
        $plusButton = $addQuantityBox.find('.x-add-plus'),
        $value = $addQuantityBox.find('.x-add-value'),
        $addButton = $addButtonBox.find('.x-add-button'),
        $productPrice = $addQuantityBox.parents('.x-product-box').find('.x-product-price, .combo__price'),
        productId = $addButton.attr('data-entity'),
        currentValue = parseInt($value.length > 1 ? $value.eq(0).text() : $value.text()),
        newValue = 0,
        $basketProduct = $(`[data-entity="basket-popup-item"][data-product="${productId}"]`);

      data.append('id', productId)
      data.append('action', action)

      if ( !quantityChangingOperations.products.hasOwnProperty(productId) ) {
        quantityChangingOperations.products[productId] = 0;
      }

      // Указание дня в меню по дням
      if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
        data.append('date', window.catalogFilterDate)
      } else {
        if ($(document).find('.js-catalog-menu-day.day_active').length) {
          data.append('date', $(document).find('.js-catalog-menu-day.day_active').attr('data-date'))
        }
      }

      if (action === 'add') {
        newValue = currentValue + 1

        quantityChangingOperations.products[productId] += 1;
      } else if (action === 'delete_one') {
        newValue = currentValue - 1

        if ( newValue < 0 ) {
            return;
        }

        quantityChangingOperations.products[productId] -= 1;
      }

      if ($value.length) {
        $value.text(newValue)
        if (action === 'add') {
          $addButton.prop('disabled', true)
          $plusButton.addClass('active')
          $addButton.fadeOut(250, function () {
            $addQuantityBox.fadeIn(150)
          })
        } else if (action === 'delete_one') {
          if (newValue === 0) {
            $addButton.prop('disabled', false)
            $plusButton.removeClass('active')
            $addQuantityBox.fadeOut(250, function () {
              $addButton.fadeIn(150)
            })
          }
        }
      }


      if ( $basketProduct.length ) {
          let $basketProductQuantity = $basketProduct.find('input.quant__input');
          let basketProductQuantity = parseInt($basketProductQuantity.val());
          let productPrice = parseInt($productPrice.get(0).textContent.replaceAll(/[\D\s]/gm, ''));
          let $basketTotalPrice = $basketProduct.parents('#basket_items').find('[data-entity="popup-basket-summ"]');
          let basketTotalPrice = parseInt($basketTotalPrice.get(0).textContent.replaceAll(/[\D\s]/gm, ''));
          let $commonBasketPrice = $('.rack .rack__digits');
          let $commonBasketCount = $('.rack .rack__round');
          let commonBasketCount = parseInt($commonBasketCount.text()) ?? 0;

          if ( action === 'add' ) {
              $commonBasketCount.text(commonBasketCount + 1);
              $basketProductQuantity.val(basketProductQuantity + 1);
              $basketTotalPrice.text(getFormattedPriceAsText(basketTotalPrice + productPrice));
              $commonBasketPrice.text(getFormattedPriceAsText(basketTotalPrice + productPrice));
          } else {
              $commonBasketCount.text(commonBasketCount - 1);
              $basketProductQuantity.val(basketProductQuantity - 1);
              $basketTotalPrice.text(getFormattedPriceAsText(basketTotalPrice - productPrice));
              $commonBasketPrice.text(getFormattedPriceAsText(basketTotalPrice - productPrice));
          }
      }

      action = quantityChangingOperations.products[productId] > 0 ? 'add_quantity' : 'delete_quantity';

      data.set('action', action);
      data.set('quantity', quantityChangingOperations.products[productId]);

      if ( !quantityChangingOperations.productsTasks.hasOwnProperty(productId) ) {
          quantityChangingOperations.productsTasks[productId] = setTimeout(() => {
              window.sendUpdateProductQuantityRequest(data);
          }, 1500);
      } else {
          clearTimeout(quantityChangingOperations.productsTasks[productId]);

          quantityChangingOperations.productsTasks[productId] = setTimeout(() => {
              window.sendUpdateProductQuantityRequest(data);
          }, 1500);
      }
    }

    window.sendUpdateProductQuantityRequest = (data) => {
      $('.product__quantity button, .cottage__quantity button').attr('disabled', 'disabled');

      return $.ajax({
        method: 'POST',
        url: '/ajax/basketItem.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (result) {
          if (result.success) {
            reloadBasket(undefined, undefined, true)
          }

          quantityChangingOperations.products[data.get('id')] = null;

          $('.product__quantity button, .cottage__quantity button').removeAttr('disabled');

          window.happyNewYearNotWorking(result)
        }
      })
    }

    // Смена торогового предложения - порция
    window.changeOfferPortions = function () {
      if ($(document).find('.x-product-portion-box').length) {
        console.log('changeOfferPortions')
        $(document).find('.x-product-portion-box').each(function () {
          var $select = $(this).find('.x-product-portion:checked'),
            $productBox = $(this).parents('.x-product-box'),
            $addBox = $productBox.find('.x-add-box'),
            $priceBox = $productBox.find('.x-price-box')

          $addBox.find('.x-add-button').attr('data-entity', $select.data('offer'))
          $addBox.find('.x-add-quantity').find('.x-add-value').attr('data-q-id', $select.data('offer'))

          $priceBox.find('.x-product-price').text($select.data('price'))
          if ($select.data('oldprice')) {
            $priceBox.find('.x-product-price-old').text($select.data('oldprice'))
          }

          let $compositionBox = $productBox.find('.x-product-composition-box')
          let $weightBox = $productBox.find('.x-product-weight-box')
          let $weightValue = $productBox.find('.x-product-weight')
          let $weightValueMobile = $productBox.find('.product__info-mobile_weight');

          if ($select.data('weight') !== '') {
            $weightValue.text($select.data('weight') + ' гр.');
            $weightValueMobile.text(`Вес ${$select.data('weight')} гр.`);
            $weightBox.removeClass('hide')
            $compositionBox.addClass('hide')
          } else {
            if ($(this).data('weight') !== '') {
              $weightValue.text($(this).data('weight') + ' гр.');
              $weightValueMobile.text(`Вес ${$(this).data('weight')} гр.`);
              $weightBox.removeClass('hide')
              $compositionBox.addClass('hide')
            } else {
              $weightBox.addClass('hide')
              $compositionBox.removeClass('hide')
            }
          }
        })

        window.listBasketItemsDay()
      }
    }
    // Смена торогового предложения - гарнир
    window.changeOfferGarnish = function () {
      if ($(document).find('.x-garnish-select').length) {
        $(document).find('.x-garnish-select').each(function () {
          var $select = $(this).find(':selected'),
            $productBox = $(this).parents('.x-product-box'),
            $addBox = $productBox.find('.x-add-box'),
            $priceBox = $productBox.find('.x-price-box')

          Cookies.set('garnish-select-' + $productBox.data('id'), $select.data('offer'))

          $addBox.find('.x-add-button').attr('data-entity', $select.data('offer'))
          $addBox.find('.x-add-quantity').find('.x-add-value').attr('data-q-id', $select.data('offer'))

          $priceBox.find('.x-product-price').text($select.data('price'))
          if ($select.data('oldprice')) {
            $priceBox.find('.x-product-price-old').text($select.data('oldprice'))
          }
            /*
          if ($select.data('img') !== '') {
            $productBox.find('.x-product-img').css('background-image', 'url(' + $select.data('img') + ')')
          } else {
            $productBox.find('.x-product-img').css('background-image', 'url(' + $(this).data('img') + ')')
          }
          */

          let $compositionBox = $productBox.find('.x-product-composition-box')
          let $weightBox = $productBox.find('.x-product-weight-box')
          let $weightValue = $productBox.find('.x-product-weight')
          let $weightValueMobile = $productBox.find('.product__info-mobile_weight');

          if ($select.data('weight') !== '') {
            $weightValue.text($select.data('weight') + ' гр.');
            $weightValueMobile.text(`Вес ${$select.data('weight')} гр.`);
            $weightBox.removeClass('hide')
            $compositionBox.addClass('hide')
          } else {
            if ($(this).data('weight') !== '') {
              $weightValue.text($(this).data('weight') + ' гр.');
              $weightValueMobile.text(`Вес ${$(this).data('weight')} гр.`);
              $weightBox.removeClass('hide')
              $compositionBox.addClass('hide')
            } else {
              $weightBox.addClass('hide')
              $compositionBox.removeClass('hide')
            }
          }

          if ($productBox.find('.x-product-text').length) {
            if ($select.data('text') !== '') {
              $productBox.find('.x-product-text').html(window.htmlspecialcharsDecode($select.data('text'), 'ENT_NOQUOTES'))
            } else {
              $productBox.find('.x-product-text').html(window.htmlspecialcharsDecode($(this).data('text'), 'ENT_NOQUOTES'))
            }
          }

          let $energy = $productBox.find('.x-product-energy-ico-prot')
          if ($energy.length) {
            if ($select.data('prot') !== 0) {
              $energy.find('.product__energy-value').html($select.data('prot'))
              $energy.removeClass('hide')
            } else {
              if ($(this).data('prot') !== 0) {
                $energy.find('.product__energy-value').html($(this).data('prot'))
                $energy.removeClass('hide')
              } else {
                $energy.addClass('hide')
              }
            }
          }

          $energy = $productBox.find('.x-product-energy-ico-ccal')
          if ($energy.length) {
            if ($select.data('ccal') !== 0) {
              $energy.find('.product__energy-value').html($select.data('ccal'))
              $energy.removeClass('hide')
            } else {
              if ($(this).data('ccal') !== 0) {
                $energy.find('.product__energy-value').html($(this).data('ccal'))
                $energy.removeClass('hide')
              } else {
                $energy.addClass('hide')
              }
            }
          }

          $energy = $productBox.find('.x-product-energy-ico-fats')
          if ($energy.length) {
            if ($select.data('fats') !== 0) {
              $energy.find('.product__energy-value').html($select.data('fats'))
              $energy.removeClass('hide')
            } else {
              if ($(this).data('fats') !== 0) {
                $energy.find('.product__energy-value').html($(this).data('fats'))
                $energy.removeClass('hide')
              } else {
                $energy.addClass('hide')
              }
            }
          }

          $energy = $productBox.find('.x-product-energy-ico-carb')
          if ($energy.length) {
            if ($select.data('carb') !== 0) {
              $energy.find('.product__energy-value').html($select.data('carb'))
              $energy.removeClass('hide')
            } else {
              if ($(this).data('carb') !== 0) {
                $energy.find('.product__energy-value').html($(this).data('carb'))
                $energy.removeClass('hide')
              } else {
                $energy.addClass('hide')
              }
            }
          }
        })
        window.listBasketItemsDay()
      }
    }

    // Товары и предложения из стоп листа
    window.stopListProductsAndOffers = function () {

      let dataStopListPreloaded = {};
      if (window.stopListPreloaded){
        dataStopListPreloaded = window.stopListPreloaded;
        dataStopListPreloaded.success = true;
      }
      let $xProductBox = $(document).find('.x-product-box')
      if ($xProductBox.length) {
        if ($xProductBox.length) {
          let fnUpdateStoplistData = (result) =>{
            if (result.success) {
              if (current_date == select_date) {
                stoplistProducts = result.listProducts;
                stoplistOffers = result.listOffers;
              } else {
                stoplistProducts = [];
                stoplistOffers = [];
              }

              var arStopListIdProducts = [],
                arStopListIdOffers = [],
                changePortion = false,
                changeGarnich = false

              $(document).find('.x-combo-detail-dinner').removeClass('product__stoplist-dinner')
              $.each(stoplistProducts, function (key, val) {
                arStopListIdProducts[val] = 'Y'
                $(document).find('.x-combo-detail-dinner-' + val).addClass('product__stoplist-dinner')
                $(document).find('.x-camp-link-' + val).addClass('product__stoplist-camp-link')
              })
              $.each(stoplistOffers, function (key, val) {
                arStopListIdOffers[val] = 'Y'
              })

              $xProductBox.each(function () {
                var $box = $(this),
                  id = $box.attr('data-id')

                if ($box.parents('.x-dinner-box').length) {
                  $box = $box.parents('.x-dinner-box')
                }
                if (arStopListIdProducts[id] === 'Y') {
                  $box.addClass('product__stoplist')
                  window.stopListOffersClear($box)
                } else {
                  var $selectGarnish = $box.find('.x-garnish-select'),
                    $boxPortion = $box.find('.x-product-portion-box'),
                    $boxGarnish = $box.find('.x-garnish-box')
                  if ($boxGarnish.length) {
                    var allOptions = true
                    $selectGarnish.find('option').each(function () {
                      var idOffer = $(this).attr('data-offer')
                      if (arStopListIdOffers[idOffer] !== 'Y') {
                        allOptions = false
                        return false
                      }
                    })
                    if (!allOptions) {
                      $selectGarnish.find('option').each(function () {
                        var $option = $(this),
                          idOffer = $option.attr('data-offer')
                        if (arStopListIdOffers[idOffer] === 'Y') {
                          window.stopListOfferGarnishAvailability($option, idOffer, false)
                          if ($option.is(':selected')) {
                            changeGarnich = true
                          }
                        } else {
                          window.stopListOfferGarnishAvailability($option, idOffer, true)
                        }
                      })
                      if (changeGarnich) {
                        $selectGarnish.each(function () {
                          var $select = $(this),
                            $parent = $select.parents('.x-garnish-box')
                          $select.find('option').attr('selected', false)
                          $select.find('option').each(function () {
                            if (!$(this).hasClass('hide')) {
                              $(this).attr('selected', true)
                              $parent.find('.product__garnish-opener').find('span').html($(this).html())
                              $parent.find('.garnish__opener').find('span').html($(this).html())
                              window.changeOfferGarnish()
                              return false
                            }
                          })
                        })
                      }
                      $box.removeClass('product__stoplist')
                      $boxGarnish.removeClass('hide')
                    } else {
                      $box.addClass('product__stoplist')
                      $boxGarnish.addClass('hide')
                    }
                  } else if ($boxPortion.length) {
                    $boxPortion.each(function () {
                      var $portionBox = $(this),
                        stopPortion = false
                      $portionBox.find('.x-product-portion').each(function () {
                        var idOffer = $(this).attr('data-offer')
                        if (arStopListIdOffers[idOffer] === 'Y') {
                          stopPortion = true
                        }
                      })
                      if (!stopPortion) {
                        $portionBox.removeClass('hide')
                        $box.removeClass('product__stoplist')
                      } else {
                        $box.addClass('product__stoplist')
                        $portionBox.addClass('hide')
                      }
                    })
                  } else {
                    $box.removeClass('product__stoplist')
                  }
                }
              })
            } else {
              $xProductBox.each(function () {
                var $box = $(this)

                if ($box.parents('.x-dinner-box').length) {
                  $box = $box.parents('.x-dinner-box')
                }
                $box.removeClass('product__stoplist')
              })
            }
          }
          if (dataStopListPreloaded.success !== undefined){
            fnUpdateStoplistData(dataStopListPreloaded);
          }else{
            $.ajax({
              method: 'POST',
              url: '/ajax/stopListCatalog.php',
              cache: false,
              contentType: false,
              processData: false,
              dataType: 'json',
              success: function (result) {
                fnUpdateStoplistData(result);
              }
            })
          }


        }
      }
    }
    // Проверка количества товаров в корзине
    window.listBasketItemsDay = function ($basket = false) {
      if ($(document).find('.x-product-box').length) {
        var data = new FormData(),
          flag = true

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('day', window.catalogFilterDate)
        } else {
          if ($(document).find('.js-catalog-menu-day.day_active').length) {
            data.append('day', $(document).find('.js-catalog-menu-day.day_active').attr('data-date'))
            select_date = data.get('day');
            if ($basket) {
              if ($(document).find('.day_active.js-basket-menu-day-popup').length) {
                if ($(document).find('.js-catalog-menu-day.day_active').attr('data-date') !== $(document).find('.day_active.js-basket-menu-day-popup').attr('data-date')) {
                  flag = false
                }
              }
            }
          }
        }

        if (flag) {
          $.ajax({
            method: 'POST',
            url: '/ajax/listBasketItemsDay.php',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (result) {
              $(document).find('.x-product-box').each(function () {
                let $addButton = $(this).find('.x-add-button'),
                  $addQuantity = $(this).find('.x-add-quantity'),
                  $addValue = $(this).find('.x-add-value'),
                  id = $addButton.attr('data-entity')

                if (result.list[id] > 0) {
                  $addValue.text(result.list[id])
                  $addButton.prop('disabled', true)
                  $addQuantity.find('.x-add-plus').addClass('active')
                  $addButton.fadeOut(250, function () {
                    $addQuantity.fadeIn(150)
                  })
                } else {
                  $addButton.prop('disabled', false)
                  $addValue.text(0)
                  $addQuantity.find('.x-add-plus').removeClass('active')
                  $addQuantity.fadeOut(250, function () {
                    $addButton.fadeIn(150)
                  })
                }
              })
            }
          })
        }
      }
    }
    window.stopListProductsAndOffers()


    window.wrapperColCustomScrollbar = function wrapperColCustomScrollbar (destroy = false) {
      var $xWrapperCol = $(document).find('.x-wrapper-col')
      if ($xWrapperCol.length) {
        var hWrapper = 0,
          hContent = $(document).find('.js-catalog-content').height()

        $(document).find('.x-wrapper-col').find('.x-dinner').each(function () {
          hWrapper = hWrapper + $(this).outerHeight(true)
        })
        if (hWrapper >= hContent) {
          $(document).find('.x-grid-padding-x').removeClass('grid-padding-x')
          $(document).find('.x-catalog-content-cell').removeClass('cell')
          $(document).find('.x-catalog-content-grid-x').removeClass('grid-x').removeClass('grid-padding-x')
          $(document).find('.x-dinner-box').addClass('cell_fix')
          /*$xWrapperCol.mCustomScrollbar({
            mouseWheel: {enable: true, preventDefault: false},
          });*/
          // freezeScroll('.mCSB_container');

          if (destroy) {
            /* $xWrapperCol.mCustomScrollbar("destroy");
             $xWrapperCol.mCustomScrollbar({
               mouseWheel: {enable: true, preventDefault: false},
             });*/
            //  freezeScroll('.mCSB_container');
          }
        } else {
          //$xWrapperCol.mCustomScrollbar("destroy");
          $(document).find('.x-grid-padding-x').addClass('grid-padding-x')
          $(document).find('.x-catalog-content-cell').addClass('cell')
          $(document).find('.x-catalog-content-grid-x').addClass('grid-x').addClass('grid-padding-x')
        }
        $xWrapperCol.removeClass('x-wrapper-col')
      }
    }

    $(document).ready(function () {
      wrapperColCustomScrollbar()
      /**
       * Переход в категорию - удалил, убрали ajax
       */

      /**
       * отображение детально комбо - удалил, убрали ajax
       */

      /**
       * Pop-up с детальной информацией о блюде
       */
      $(document).on('click', '.js-item-dish', function (e) {
        e.preventDefault()
        e.stopPropagation()

        var _this = $(this),
          data = new FormData,
          hide_buy = _this.find('.cottage__quantity').length === 0

        data.append('id', _this.data('id'))
        data.append('date', window.catalogFilterDate)
        $.ajax({
          method: 'POST',
          url: '/local/templates/.default/components/bitrix/catalog.section/main/ajax/get_dish.php' + (hide_buy ? '?hide_buy=true' : ''),
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            console.log('call node')
            if (data) {
              let insertWrap = $('.modalCardCont')
              insertWrap.html(data)
              openPopupCard()
            }
          }
        })
      })
      /**
       * Pop-up с детальной информацией о блюде - combo
       */
      $(document).on('click', '.x-item-dish-combo', function (e) {
        e.preventDefault()
        e.stopPropagation()

        var _this = $(this),
          data = new FormData,
          hide_buy = _this.find('.cottage__quantity').length === 0

        data.append('id', _this.data('id'))

        $.ajax({
          method: 'POST',
          url: '/local/templates/.default/components/bitrix/catalog.section/main/ajax/get_dish.php' + (hide_buy ? '?hide_buy=true' : ''),
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            if (data) {
              $(document).find('.modalCardCont').html(data)
              openPopupCard()
            }
          }
        })
      })

      /**
       * Добавление в корзину (увеличение количества в корзине из карточки товара)
       */
      $(document).on('click', '.cottage__quantity .cottage__plus', function (e) {
        if (!$(this).hasClass('x-add-plus')) {
          console.log('cottage__plus')
          var _this = $(this),
            action = 'add',
            data = new FormData(),
            product_id = _this.closest('.item-dish').data('id'),
            v = parseInt($('.cottage__value', _this.closest('.item-dish')).text())

          e.preventDefault()
          e.stopPropagation()

          if (v <= 300) {
            data.append('id', product_id)
            data.append('action', action)
            var additives = []
            _this.parents().find('.relativePos').each(function (key, item) {
              if ($(item).find('.imgContSlider').hasClass('active')) {
                data.append('additives[]', $(item).data('id'))
              }
            })

            // Указание дня в меню по дням
            if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
              data.append('date', window.catalogFilterDate)
            }

            $.ajax({
              method: 'POST',
              url: '/ajax/basketItem.php',
              data: data,
              cache: false,
              contentType: false,
              processData: false,
              dataType: 'json',
              success: function (result) {
                if (result.success) {
                  _this.addClass('active')
                  v = parseInt($('.cottage__value', _this.closest('.item-dish')).text())
                  $('.cottage__value', _this.closest('.item-dish')).text(v + 1)
                  var add_button = $('.addButton')
                  if (!add_button.hasClass('active')) {
                    add_button.addClass('active')
                    setTimeout(function () {
                      if (add_button.hasClass('active')) {
                        add_button.removeClass('active')
                      }
                    }, 175)
                  }
                  reloadBasket(undefined, undefined, true)
                }
                window.happyNewYearNotWorking(result)
              }
            })
          }
        }
      })

      $(document).on('click', '[data-action="show-popup-address"]', function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (window.userLocationPopup instanceof UserLocationPopup) {
          userLocationPopup.show()
        } else {
          window.userLocationPopup = new UserLocationPopup()
          userLocationPopup.show()
        }
        if (typeof showDeliveryLocationPopup !== 'undefined') {
          showDeliveryLocationPopup = false
        }
      })

      /**
       * Удаление из корзины (уменьшение количества в корзине из карточки товара)
       */
      $(document).on('click', '.cottage__quantity .cottage__minus', function (e) {
        if (!$(this).hasClass('x-add-minus')) {
          var _this = $(this),
            action = 'delete_one',
            data = new FormData(),
            product_id = _this.closest('.item-dish').data('id'),
            v = parseInt($('.cottage__value', _this.closest('.item-dish')).text())

          e.preventDefault()
          e.stopPropagation()

          if (v > 0) {
            data.append('id', product_id)
            data.append('action', action)
            var additives = []
            _this.parents().find('.relativePos').each(function (key, item) {
              if ($(item).find('.imgContSlider').hasClass('active')) {
                data.append('additives[]', $(item).data('id'))
              }
            })

            // Указание дня в меню по дням
            if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
              data.append('date', window.catalogFilterDate)
            }

            $.ajax({
              method: 'POST',
              url: '/ajax/basketItem.php',
              data: data,
              cache: false,
              contentType: false,
              processData: false,
              dataType: 'json',
              success: function (result) {
                if (result.success) {
                  v = parseInt($('.cottage__value', _this.closest('.item-dish')).text())
                  if (v === 1) $('.cottage__plus', _this.closest('.item-dish')).removeClass('active')

                  if (v !== 1) {
                    $('.cottage__value', _this.closest('.item-dish')).text(v - 1)
                  }

                  let quantityBlock = $(_this).parents('.cottage__quantity')
                  let addButton = quantityBlock.parent().find('.js-cottage-button')

                  if (v === 1) {
                    quantityBlock.fadeOut(250, function () {
                      addButton.fadeIn(250)
                      $('.cottage__value', _this.closest('.item-dish')).text(0)
                    })
                  } else {
                    console.log('acttion 2')
                  }
                  reloadBasket(undefined, undefined, true)
                }
                window.happyNewYearNotWorking(result)
              }
            })
          }
        }
      })

      /**
       * Фильтрация по категории в каталоге "Меню дня"
       */
      $(document).on('click', '.js-catalog-section-filter', function (e) {
        var $this = $(this),
          $sectionFilterLinks = $('.js-catalog-section-filter'),
          $catalogContent = $('.js-catalog-content'),
          data = new FormData

        e.preventDefault()
        e.stopPropagation()

        $(document).find('.x-combo-camp-box').html('')
        data.append('section_id', $this.data('section-id'))
        data.append('ajax_request', 'Y')

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('date', window.catalogFilterDate)
        }

        $sectionFilterLinks.removeClass('active')
        $catalogContent.fadeOut()

        $.ajax({
          method: 'POST',
          url: window.location.href,
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            if (data) {
              window.clickFilterSectionID = $this.data('section-id')
              /** обнуляем выбранное комбо если покинули раздел с комбо */
              if ($this.data('section-id') !== 16) {
                window.dateComboID = ''
              }
              $catalogContent.html(data)

              /** баннер на НГ */
              window.revealHolidayMenu($catalogContent)
              /** баннеры для разделов */
              let $promoSliders = $catalogContent.find('[data-entity="section-promo"]')
              if ($promoSliders.length) {
                $promoSliders.slick({
                  autoplay: true,
                  speed: 1500,
                  adaptiveHeight: false,
                  arrows: true,
                  dots: true,
                  prevArrow: $('.sectionbanner__prev'),
                  nextArrow: $('.sectionbanner__next'),
                })
              }

              /**
               * селекты для гарниров
               */
              try {
                let $customSelectProductsGarnish = window.customSelect('.x-garnish-custom-select', {
                  containerClass: 'garnish__container',
                  openerClass: 'garnish__opener',
                  panelClass: 'garnish__panel',
                  optionClass: 'garnish__option',
                  optgroupClass: 'custom-select-optgroup',
                  isSelectedClass: 'is-selected',
                  hasFocusClass: 'has-focus',
                  isDisabledClass: 'is-disabled',
                  isOpenClass: 'is-open'
                })
                if ($customSelectProductsGarnish.length) {
                  $customSelectProductsGarnish.forEach(function (item, key) {
                    $customSelectProductsGarnish[key]
                      .container
                      .addEventListener(
                        'custom-select:close',
                        (e) => {
                          window.changeOfferGarnish()
                        }
                      )
                  })
                }
              } catch (e) {
                console.log(e)
              }

              $.each($catalogContent.find('[data-entity="garnish-wrapper"]'), function () {
                new Garnish($(this))
              })

              $catalogContent.find('.cottage__tooltip').foundation()
              $catalogContent.find('.cottage__tooltip').on('click', function (e) {
                e.preventDefault()
                e.stopPropagation()
              })
              $this.addClass('active')
              $catalogContent.fadeIn()
            }
          }
        })
      })

      $(document).on('click', '.js-basketAction2', function (e) {
        var _this = $(this),
          action = 'add',
          data = new FormData(),
          product_id = _this.closest('.item ').data('id'),
          additives = []

        e.preventDefault()
        e.stopPropagation()

        _this.parents().find('.relativePos').each(function (key, item) {
          if ($(item).find('.imgContSlider').hasClass('active')) {
            data.append('additives[]', $(item).data('id'))
          }
        })

        data.append('id', product_id)
        data.append('action', action)

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('date', window.catalogFilterDate)
        }

        $.ajax({
          method: 'POST',
          url: '/ajax/basketItem.php',
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (result) {
            if (result.success) {
              var add_button = $('.addButton')
              if (!add_button.hasClass('active')) {
                add_button.addClass('active')
                setTimeout(function () {
                  if (add_button.hasClass('active')) {
                    add_button.removeClass('active')
                  }
                }, 175)
              }
              reloadBasket(undefined, undefined, true)
            }
            window.happyNewYearNotWorking(result)
          }
        })
        return false
      })

      $(document).on('click', '.js-basketAction', function (e) {
        var _this = $(this),
          action = 'add',
          data = new FormData(),
          product_id = _this.parents().find('.modalCard').data('id'),
          find_item = _this.closest('.gallery').find('.item[data-id=' + product_id + ']'),
          _btn = find_item.find('.plus'),
          _value = find_item.find('.value'),
          cur_value = parseInt(_value.text())

        e.preventDefault()
        e.stopPropagation()

        data.append('id', product_id)
        data.append('action', action)

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('date', window.catalogFilterDate)
        }

        _btn.addClass('active')
        _value.text(cur_value + 1)

        $.ajax({
          method: 'POST',
          url: '/ajax/basketItem.php',
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (result) {
            if (result.success) {
              var add_button = $('.addButton')
              // добавляется и пропадает класс active, чтобы при клике на кнопку, она становилась белой, а потом возвращалась обратно
              if (!add_button.hasClass('active')) {
                add_button.addClass('active')
                setTimeout(function () {
                  if (add_button.hasClass('active')) {
                    add_button.removeClass('active')
                  }
                }, 175)
              }
              reloadBasket(undefined, undefined, true)
            }
            window.happyNewYearNotWorking(result)
          }
        })
      })

      /**
       * Удаление из корзиныу (уменьшение количества в корзине из модальной карточки товара)
       */
      $(document).on('click', '.quant_totalizer .quant__minus', function (e) {
        var _this = $(this),
          action = 'delete_one',
          data = new FormData(),
          product_id = _this.parents().find('.modalCard').data('id'),
          quant__input = _this.closest('.quant_totalizer').find('.quant__input'),
          prod_input = $(document).find('.js-item-dish').find('.value[data-q-id=\'' + product_id + '\']'),
          cur_value = parseInt(quant__input.val())

        e.preventDefault()
        e.stopPropagation()

        if (cur_value > 0) {
          data.append('id', product_id)
          data.append('action', action)

          // Указание дня в меню по дням
          if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
            data.append('date', window.catalogFilterDate)
          }

          quant__input.val(cur_value - 1)
          prod_input.text(cur_value - 1)

          var addButtonCottage = $(document).find('.js-cottage-button[data-entity="' + product_id + '"]'),
            quantityBlockCottage = $(document).find('.cottage__value[data-q-id=\'' + product_id + '\']').parents('.cottage__quantity')

          if (quantityBlockCottage.length) {
            quantityBlockCottage.find('.cottage__value').text(cur_value - 1)
            if (cur_value - 1 === 0) {
              addButtonCottage.prop('disabled', false)
              addButtonCottage.fadeIn()
              quantityBlockCottage.fadeOut()
            }
          }

          $.ajax({
            method: 'POST',
            url: '/ajax/basketItem.php',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (result) {
              if (result.success) {
                reloadBasket(undefined, undefined, true)
              }
              window.happyNewYearNotWorking(result)
            }
          })
        }
      })

      /**
       * Добавление в корзину (увеличение количества в корзине из модальной карточки товара)
       */
      $(document).on('click', '.quant_totalizer .quant__plus', function (e) {
        var _this = $(this),
          action = 'add',
          data = new FormData(),
          product_id = _this.parents().find('.modalCard').data('id'),
          quant__input = _this.closest('.quant_totalizer').find('.quant__input'),
          prod_input = $(document).find('.js-item-dish').find('.value[data-q-id=\'' + product_id + '\']'),
          cur_value = parseInt(quant__input.val())

        e.preventDefault()
        e.stopPropagation()

        data.append('id', product_id)
        data.append('action', action)

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('date', window.catalogFilterDate)
        }

        quant__input.val(cur_value + 1)
        prod_input.text(cur_value + 1)
        var addButtonCottage = $(document).find('.js-cottage-button[data-entity="' + product_id + '"]'),
          quantityBlockCottage = $(document).find('.cottage__value[data-q-id=\'' + product_id + '\']').parents('.cottage__quantity')

        if (quantityBlockCottage.length) {
          quantityBlockCottage.find('.cottage__value').text(cur_value + 1)
          quantityBlockCottage.find('.cattage__plus').addClass('active')
          addButtonCottage.prop('disabled', true)
          addButtonCottage.fadeOut()
          quantityBlockCottage.fadeIn()
        }

        $.ajax({
          method: 'POST',
          url: '/ajax/basketItem.php',
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (result) {
            if (result.success) {
              reloadBasket(undefined, undefined, true)
            }
            window.happyNewYearNotWorking(result)
          }
        })
      })

      $(document).on('click', '.js-cottage-button', function (e) {
        e.preventDefault()
        e.stopPropagation()

        var _this = $(this)
        var action = 'add'
        var data = new FormData()
        var product_id = $(this).data('entity')
        data.append('id', product_id)
        data.append('action', action)

        _this.prop('disabled', true)

        // Указание дня в меню по дням
        if (!!window.catalogFilterDate && window.catalogFilterDate !== '') {
          data.append('date', window.catalogFilterDate)
        }
        $.ajax({
          method: 'POST',
          url: '/ajax/basketItem.php',
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (result) {
            if (result.success) {
              reloadBasket(undefined, undefined, true)
              let quantity = $(_this).parent().find('.cottage__quantity')
              if (quantity.length) {
                quantity.find('.cottage__value').text(1)
                quantity.find('.cattage__plus').addClass('active')
                _this.fadeOut(250, function () {
                  quantity.fadeIn(150)
                })
              }

            }
            window.happyNewYearNotWorking(result)
            if (typeof showDeliveryLocationPopup !== 'undefined' && showDeliveryLocationPopup) {
              window.userLocationPopup = new UserLocationPopup()
              setTimeout(function () {
                userLocationPopup.show()
                showDeliveryLocationPopup = false
              }, 1500)

            }
          }
        })
        setTimeout(function () {
          _this.prop('disabled', false)
        }.bind(this), 250)
      })

      /**
       * Start - Карточка товара
       */
      // Проверка количества товаров в корзине
      if (!$(document).find('.x-garnish-select').length) {
        window.listBasketItemsDay()
      } else {
        // Выбор торгового предложения в конструкции a -> select - срабатывает переход по ссылке
        $(document).on('click', '.x-product-link', function (e) {
          if ($(this).find('.x-garnish-select').length) {
            if (
              $(e.target).parents('.x-is-garnish').length
            ) {
              e.preventDefault()
              e.stopPropagation()
            }
          }
        })
      }

      // Товар с предложениями
      window.changeOfferGarnish()
      $(document).on('change', '.x-garnish-select', function (e) {
        e.preventDefault()
        e.stopPropagation()

        window.changeOfferGarnish()
      })
      window.changeOfferPortions()
      $(document).on('change', '.x-product-portion', function (e) {
        e.preventDefault()
        e.stopPropagation()

        window.changeOfferPortions()
      })

      // Добавление товара в корзину
      $(document).on('click', '.x-add-button', function (e) {
        e.preventDefault()
        e.stopPropagation()

        window.changeQuantityProduct($(this).parents('.x-product-box').find('.x-add-box'), 'add')

        if (typeof showDeliveryLocationPopup !== 'undefined' && showDeliveryLocationPopup) {
          window.userLocationPopup = new UserLocationPopup()
          setTimeout(function () {
            userLocationPopup.show()
            showDeliveryLocationPopup = false
          }, 1500)
        }
      })

      // Добавление в корзину
      $(document).on('click', '.x-add-plus', function (e) {
        e.preventDefault()
        e.stopPropagation()

        console.log('x-add-plus')
        window.changeQuantityProduct($(this).parents('.x-product-box').find('.x-add-box'), 'add')
      })

      // Удаление из корзины
      $(document).on('click', '.x-add-minus', function (e) {
        e.preventDefault()
        e.stopPropagation()

        window.changeQuantityProduct($(this).parents('.x-product-box').find('.x-add-box'), 'delete_one')
      })
      /**
       * End - Карточка товара
       */
    })

    var scrollEvents = ['wheel', 'mousewheel']

// Отключение скролла страницы, когда курсор находится над div с прокруткой (при достижении верха или низа прокручиваемой области)
    function freezeScroll () {
      for (var i = 0; i < arguments.length; i++) {
        var elem = arguments[i]
        let func = preventScrollEventFunc(elem)
        let options = { passive: false }
        $(elem).on('mouseenter', function () {
          onWheel(window, func, options)
        }).on('mouseleave', function () {
          removeOnWheel(window, func)
        })
      }
    }

// Отменить скролл страницы, если элемент selector прокручен до упора
    function preventScrollEventFunc (selector) {
      let elem = $(selector)

      function preventScroll (e) {
        let offset = e.wheel || e.wheelDelta
        let crossingUpper = elem.scrollTop() == 0 && offset > 0
        let crossingDown = (elem[0].scrollHeight - elem.scrollTop() ==
          elem[0].clientHeight && offset < 0)
        if (crossingUpper || crossingDown) {
          e.preventDefault()
        }
      }

      return preventScroll
    }

// Повесить обработчик func для событий wheel и mousewheel у elem
    function onWheel (elem, func, options) {
      options = options || {}
      scrollEvents.forEach(function (item, i, arr) {
        elem.addEventListener(item, func, options)
      })
    }

// Убрать обработчик func для событий wheel и mousewheel у elem
    function removeOnWheel (elem, func, options) {
      options = options || {}
      scrollEvents.forEach(function (item, i, arr) {
        elem.removeEventListener(item, func, options)
      })
    }

  })
})(jQuery)
